import React from 'react'
import Navbar from 'react-bootstrap/Navbar';
import './styles.scss';
import instagram from '../../assets/images/instagram.png'
import facebook from '../../assets/images/facebook.png'
import { translations } from '../../translate'

function Footer({ language, setLanguage }) {
    return (
        <Navbar fixed='bottom' className='footerContainer'>

            <div className='footerLanguagesContainer'>
                <p onClick={() => setLanguage('en')} className={language === 'en' ? 'activeLanguage' : 'footerLanguage'}>English</p>
                <p onClick={() => setLanguage('pt')} className={language !== 'en' ? 'activeLanguage' : 'footerLanguage'}>Portuguese</p>
            </div>
            <Navbar.Collapse className="justify-content-end">
                <div className='footerSocialMediaContainer'>
                    <p>
                        {translations[language]?.follow}
                    </p>
                    <a href='https://instagram.com/hotel_preciosa?igshid=YmMyMTA2M2Y='>
                        <img src={instagram} width={30} alt="instagram" />
                    </a>
                    <a href='https://www.facebook.com/profile.php?id=100089767771284&mibextid=LQQJ4d'>
                        <img src={facebook} width={30} alt="facebook" />
                    </a>
                </div>
            </Navbar.Collapse>

        </Navbar>
    )
}

export default Footer